export const FINRA_EXCHANGE_ID = 4;
export const LARGE_TRADE_MINIMUM = 50_000_000;
